import { useGLTF } from "@react-three/drei";
import { isIOS } from "react-device-detect";

export const MODEL_PATH = "/models";

export const BODYPART_MODEL_PATH = `${MODEL_PATH}/Organ_Models_Standalone/`;

export const HUMAN_MALE_PATH = `${MODEL_PATH}/Male/Male_OpaqueAndTransparent.gltf`;
export const HUMAN_FEMALE_PATH = `${MODEL_PATH}/Female/Female_OpaqueAndTransparent.gltf`;
export const CELL_PATH = `${MODEL_PATH}/Cell/Cell.gltf`;

export const BLOOD_PATH = `${BODYPART_MODEL_PATH}/Blood/Blood_Texturing.gltf`;
export const BONES_PATH = `${BODYPART_MODEL_PATH}/Bones/Bones_Texturing.gltf`;
export const BRAIN_PATH = `${BODYPART_MODEL_PATH}/Brain/Brain_Texturing.gltf`;
export const DIGESTIVE_SYSTEM_PATH = `${BODYPART_MODEL_PATH}/Digestive_System/Digestive_Texturing.gltf`;
export const EYES_PATH = `${BODYPART_MODEL_PATH}/Eyes/Eyes_Texturing.gltf`;
export const HEART_PATH = `${BODYPART_MODEL_PATH}/Heart/Heart_Texturing.gltf`;
export const LIVER_PATH = `${BODYPART_MODEL_PATH}/Liver/Liver_Texturing.gltf`;

export const preloadGLTFAsset = (
  path: string,
  useDraco?: string | boolean | undefined,
  useMeshOpt?: boolean | undefined,
) => {
  if (!isIOS) useGLTF.preload(path, useDraco, useMeshOpt);
};

export const preloadDigitalTwin = () => {
  preloadGLTFAsset(HUMAN_MALE_PATH);
  preloadGLTFAsset(HUMAN_FEMALE_PATH);
  preloadGLTFAsset(CELL_PATH);
  preloadGLTFAsset(BLOOD_PATH);
  preloadGLTFAsset(BONES_PATH);
  preloadGLTFAsset(BRAIN_PATH);
  preloadGLTFAsset(DIGESTIVE_SYSTEM_PATH);
  preloadGLTFAsset(EYES_PATH);
  preloadGLTFAsset(HEART_PATH);
  preloadGLTFAsset(LIVER_PATH);
};
